// PaymentStatusWrapper.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import PaymentStatus from './PaymentStatus';

const PaymentStatusWrapper = () => {
  const { state } = useLocation();

  if (!state) return <div>Invalid payment session</div>;

  return (
    <PaymentStatus
      userName={state.userName}
      orderId={state.orderId}
      status={state.status}
      timestamp={state.timestamp}
      amount={state.amount}
      currencySymbol={state.currencySymbol}
    />
  );
};

export default PaymentStatusWrapper;
